export class FileProcessingType {
    readonly name: string;
    readonly id: number;

    private constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }

    public static Pending = new FileProcessingType(10, "pending");
    public static Complete = new FileProcessingType(20, "complete");
    public static Error = new FileProcessingType(100, "error");

    public static asArray = () => [
        FileProcessingType.Pending,
        FileProcessingType.Complete,
        FileProcessingType.Error
    ];

    public static fromId = (id: number) =>
        FileProcessingType.asArray().find(x => x.id === id);

    public static isPending = (id: number): boolean => id === FileProcessingType.Pending.id
    public static isComplete = (id: number): boolean => id === FileProcessingType.Complete.id
    public static isError = (id: number): boolean => id === FileProcessingType.Error.id
}
